import { BiLegendPosition, BiVizType } from '@euler/model/bi/viz';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
  BiGalleryDashboardCard,
  BiGalleryVariant,
} from '../functions/biGalleryTypes';
import {
  cents,
  kGalleryFields as f,
  galleryReady,
  galleryResult,
} from './biGalleryFields';

const technicians: [string, number, number, number][] = [
  ['王建国', 142, 136, 3],
  ['李晓明', 118, 115, 1],
  ['张伟', 131, 120, 6],
  ['刘洋', 96, 94, 2],
  ['陈志强', 109, 101, 4],
];

const team: BiGalleryDashboardCard = {
  surface: 'dashboard',
  title: '本月技师综合表现',
  viz: {
    type: BiVizType.Radar,
    x: f.technician.key,
    series: [
      { key: f.jobs.key },
      { key: f.finishedJobs.key },
      { key: f.reworks.key },
    ],
  },
  data: galleryReady(
    galleryResult(
      [f.technician, f.jobs, f.finishedJobs, f.reworks],
      technicians.map(([name, jobs, finished, reworks]) => [
        name,
        jobs,
        finished,
        reworks,
      ]),
    ),
  ),
};

const kTypes = ['保养', '钣喷', '轮胎', '美容', '维修', '检测'];
const revenue = [
  [124300, 81600, 48000, 21400, 96500, 12800],
  [119800, 74200, 44600, 26900, 88300, 15100],
];

const byType: BiGalleryDashboardCard = {
  surface: 'dashboard',
  title: '各业务配件与工时营收',
  viz: {
    type: BiVizType.Radar,
    x: f.serviceType.key,
    series: [{ key: f.partsRevenue.key }, { key: f.laborRevenue.key }],
  },
  data: galleryReady(
    galleryResult(
      [f.serviceType, f.partsRevenue, f.laborRevenue],
      kTypes.map((type, i) => [
        type,
        cents(revenue[0][i]),
        cents(revenue[1][i]),
      ]),
    ),
  ),
};

const kJobs = ['机油保养', '刹车片', '四轮定位', '空调清洗', '轮胎更换'];

function splitCard(names: string[], title: string): BiGalleryDashboardCard {
  return {
    surface: 'dashboard',
    title,
    viz: {
      type: BiVizType.Radar,
      x: f.jobName.key,
      series: [{ key: f.jobs.key }],
      seriesBy: f.technician.key,
    },
    data: galleryReady(
      galleryResult(
        [f.jobName, f.technician, f.jobs],
        names.flatMap((name, t) =>
          kJobs.map((job, j) => [job, name, 8 + ((t * 7 + j * 5) % 23)]),
        ),
      ),
    ),
  };
}

const split = splitCard(['王建国', '李晓明', '张伟'], '技师各项目施工数');

function withStyle(
  key: string,
  name: string,
  note: string,
  card: BiGalleryDashboardCard,
  style: NonNullable<BiGalleryDashboardCard['viz']['style']>,
): BiGalleryVariant {
  return { key, name, note, card: { ...card, viz: { ...card.viz, style } } };
}

export const kRadarCategory: BiGalleryCategory = {
  key: BiGalleryCategoryKey.Radar,
  name: '雷达图',
  description: '多指标综合对比、按维度拆分、填充与数据标签',
  preview: team,
  variants: [
    {
      key: 'measures',
      name: '多指标对比',
      note: '技师为辐条；单位差异大时各按自身最大值缩放',
      card: team,
    },
    {
      key: 'shared',
      name: '同单位共享刻度',
      note: '两项金额，环上标注刻度',
      card: byType,
    },
    {
      key: 'split',
      name: '按维度拆分',
      note: 'seriesBy = 技师',
      card: split,
    },
    withStyle('labels', '数据标签', 'dataLabels = true', byType, {
      dataLabels: true,
    }),
    withStyle('no-fill', '不填充', 'radar.fillOpacity = 0', split, {
      radar: { fillOpacity: 0 },
    }),
    withStyle('deep-fill', '深填充', 'radar.fillOpacity = 0.6', team, {
      radar: { fillOpacity: 0.6 },
    }),
    withStyle('legend-right', '图例右侧', 'legend.position = right', team, {
      legend: { show: true, position: BiLegendPosition.Right },
    }),
    {
      key: 'over-five',
      name: '超过 5 组',
      note: '只画前 5 组，其余见数据表',
      card: splitCard(
        ['王建国', '李晓明', '张伟', '刘洋', '陈志强', '杨帆', '赵磊'],
        '七位技师各项目施工数',
      ),
    },
  ],
};
